import { Injectable, Injector } from '@angular/core';
import { UserService } from '@carm/_core/access-control-mgt/facade/user.service';
import { AccessUserService } from '@carm/_core/access-control-mgt/services/access-user.service';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  IValidateClassificationNumberResponse,
  IInitDataResponse,
  ITariffTreatmentResponse,
  ISubmitCalculatorRequest,
  ISubmitCalculatorResponse,
} from '../models';

@Injectable()
export class CalculatorService extends BaseApiService {
  constructor(
    protected injector: Injector,
    public userService: UserService,
    public accessUserService: AccessUserService
  ) {
    super(injector);
  }

  // Sends request to API to get the initial options for calculator form
  public getInitData(): Observable<IInitDataResponse> {
    const url = `${environment.business.declarations.calculator.baseUrl}/init-data`;
    return this.httpAuthGet<IInitDataResponse>(url);
  }

  // Sends request to API to get the units of measure. escription and exciseCode for calculator form
  public validateClassificationNumber(
    classNumber: string
  ): Observable<IValidateClassificationNumberResponse> {
    const url = `${environment.business.declarations.calculator.baseUrl}/validate-classification-number-and-get-details?classificationNumber=${classNumber}`;
    return this.httpAuthGet<IValidateClassificationNumberResponse>(url);
  }

  // Sends selected country of origin and the place of export to API to get the list of tariffs
  public getTariffTreatment(
    classificationNumber: string,
    countryOrigin: string,
    placeExport: string
  ): Observable<ITariffTreatmentResponse> {
    const url =
      `${environment.business.declarations.calculator.baseUrl}/tariff-treatment` +
      `?classificationNumber=${classificationNumber}&countryOfOrigin=${countryOrigin}&placeOfExport=${placeExport}`;
    return this.httpAuthGet<ITariffTreatmentResponse>(url);
  }

  // Submits the input data of the calculator nd received the results
  public submitCalculatorValues(
    inputData: ISubmitCalculatorRequest
  ): Observable<ISubmitCalculatorResponse> {
    const url = `${environment.business.declarations.calculator.baseUrl}/tax-and-duties`;
    return this.httpAuthPost<ISubmitCalculatorResponse>(url, inputData);
  }
}
